[
  {"keys": ["Heliodor", "ExternalScript"], "code": 3},
  {"keys": ["Heliodor", "ExternalScript", "Other"], "code": 0},
  {"keys": ["Heliodor", "ExternalScript", "Other", "Other"], "code": 0},
  {"keys": ["Heliodor", "ExternalScript", "Other", "Other", "UncaughtError"], "code": 0},
  {"keys": ["Platform", "TypeScript"], "code": 1},
  {"keys": ["Platform", "TypeScript", "MediaStream"], "code": 1},
  {"keys": ["Platform", "TypeScript", "MediaStream", "Audio"], "code": 1},
  {"keys": ["Platform", "TypeScript", "MediaStream", "Audio", "Other"], "code": 1},
  {"keys": ["Platform", "TypeScript", "MediaStream", "Audio", "Exception"], "code": 2},
  {"keys": ["Platform", "TypeScript", "MediaStream", "Audio", "MicDeviceException"], "code": 3},
  {"keys": ["Platform", "TypeScript", "MediaStream", "Audio", "MicDeviceChange"], "code": 4},
  {"keys": ["Platform", "TypeScript", "Config"], "code": 2},
  {"keys": ["Platform", "TypeScript", "Config", "Status"], "code": 1},
  {"keys": ["Platform", "TypeScript", "Config", "Status", "NotFound"], "code": 1},
  {"keys": ["RTC", "OldSkyway"], "code": 2},
  {"keys": ["RTC", "OldSkyway", "Other"], "code": 0},
  {"keys": ["RTC", "OldSkyway", "Other", "Other"], "code": 0},
  {"keys": ["RTC", "OldSkyway", "Other", "Other", "Other"], "code": 0},
  {"keys": ["RTC", "OldSkyway", "Peer"], "code": 1},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event"], "code": 1},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "RoomError"], "code": 1},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "Permission"], "code": 2},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "ListError"], "code": 3},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "Disconnected"], "code": 4},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "SocketError"], "code": 5},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "InvalidId"], "code": 6},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "UnavailableId"], "code": 7},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "InvalidKey"], "code": 8},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "InvalidDomain"], "code": 9},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "Authentication"], "code": 10},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "ServerError"], "code": 11},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "SFUClientNotSupported"], "code": 12},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "PeerUnavailable"], "code": 13},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "SignalingLimited"], "code": 14},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "SFULimited"], "code": 15},
  {"keys": ["RTC", "OldSkyway", "Peer", "Event", "TurnLimited"], "code": 16}
]
